import {Directive, HostListener, Input} from '@angular/core';
import {StateService} from "@tva/ng-migration/core/services/state/state.service";

@Directive({
    selector: '[redirectTo]'
})
export class RedirectToDirective {
    @Input() redirectTo: string;

    constructor(private state: StateService) {
    }

    @HostListener('click') onClick() {
        this.state.go(this.redirectTo);
    }
}
